import React, { useState } from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./design-system/Dropdown";
import DropboxAccountReady from "./DropboxAccountReady";
import AddCircleIconBlack from "../../assets/svgIcons/add-circle-icon-black.svg";
import refresh from "../../assets/svgIcons/refresh.svg";
import cross from "../../assets/svgIcons/cross-icon.svg";
import type { IntegrationAPIResponse } from "../IntegrationModal";

const ResyncDropdown = ({
  account,
  cancelSourceItemsSync,
  handleUploadFilesClick,
  resyncDataSource,
}: {
  resyncDataSource: (id: number) => void;
  account: IntegrationAPIResponse;
  handleUploadFilesClick: (account?: IntegrationAPIResponse) => void;
  cancelSourceItemsSync: (id?: number) => void;
}) => {
  const [isDropboxAccountReady, setIsDropboxAccountReady] =
    useState<boolean>(false);

  const commonMenuConponent = () => {
    return (
      <DropdownMenuContent align="end" className="cc-w-[153px] cc-py-[8px] ">
        <DropdownMenuGroup>
          <DropdownMenuItem
            className="!cc-px-[16px] cc-border-outline-base_em hover:cc-bg-surface-surface_1 dark:cc-border-b-dark-border-color"
            onClick={() => resyncDataSource(account.id)}
          >
            <div className="cc-flex cc-justify-between cc-items-center cc-w-full">
              <p className="cc-text-xs cc-font-semibold cc-text-high_em dark:cc-text-dark-text-white">
                Re-Sync
              </p>
              <img
                alt="resync"
                className="cc-w-[13px] cc-h-[13px]"
                src={refresh}
              />
            </div>
          </DropdownMenuItem>
          <DropdownMenuItem
            className="!cc-px-[16px] cc-border-outline-base_em hover:cc-bg-surface-surface_1 dark:cc-border-b-dark-border-color"
            onClick={() => handleUploadFilesClick(account)}
          >
            <div className="cc-flex cc-justify-between cc-items-center cc-w-full">
              <p className="cc-text-xs cc-font-semibold cc-text-high_em dark:cc-text-dark-text-white">
                Select Files
              </p>

              <img
                alt="select"
                className='cc-w-[13px] cc-h-[13px] dark:cc-invert-[1] dark:cc-hue-rotate-180"'
                src={AddCircleIconBlack}
              />
            </div>
          </DropdownMenuItem>
          {account.sync_status == "SYNCING" ? (
            <DropdownMenuItem
              className="!cc-px-[16px] cc-border-outline-base_em hover:cc-bg-surface-surface_1 dark:cc-border-b-dark-border-color"
              onClick={() => cancelSourceItemsSync(account.id)}
            >
              <div className="cc-flex cc-justify-between cc-items-center cc-w-full">
                <p className="cc-text-xs cc-font-semibold cc-text-high_em dark:cc-text-dark-text-white">
                  Cancel Sync
                </p>

                <img
                  alt="cancel"
                  className="cc-w-[13px] cc-h-[13px]"
                  src={cross}
                />
              </div>
            </DropdownMenuItem>
          ) : null}
        </DropdownMenuGroup>
      </DropdownMenuContent>
    );
  };

  return (
    <>
      <DropboxAccountReady
        isOpen={isDropboxAccountReady}
        onOpenChange={setIsDropboxAccountReady}
      />

      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <svg
            className="cc-cursor-pointer addIconsvg dark:cc-invert-[1] dark:cc-hue-rotate-180"
            fill="none"
            height="18"
            viewBox="0 0 18 18"
            width="18"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              clipRule="evenodd"
              d="M8.99995 12.4887L3.83704 7.32583L5.16286 6L8.99995 9.83709L12.837 6L14.1629 7.32583L8.99995 12.4887Z"
              fill="black"
              fillRule="evenodd"
            />
          </svg>
        </DropdownMenuTrigger>
        {commonMenuConponent()}
      </DropdownMenu>
    </>
  );
};

export default ResyncDropdown;
